import { FC, useEffect, useState } from "react";
import { Modal, ModalHeading } from "@sainsburys-tech/luna-modal";
import { DeletePopupType } from "../../../Interfaces/IAddFieldModalProps";
import {
  ButtonGroupPrimary,
  ButtonGroupWrapper,
  FilledButton,
  OutlinedButton,
} from "@sainsburys-tech/luna-button";
import store from "../../../Store/store";
import { storeDeletePayload } from "../../../Redux/Actions/popupActions";

const DuTypePopupDelete: FC<DeletePopupType> = ({
  isOpen,
  handleClose,
  handleAddCallback: handleAdd,
  title,
  Id,
}) => {
  const [message, setMessage] = useState<string>();

  const closeHandler = () => {
    handleClose(false);
  };

  const confirm = () => {
    store.dispatch(storeDeletePayload({ deletePayload: Id }));
    handleClose(false);
  };

  useEffect(() => {
    setMessage("Are you sure you want to delete the Container Type?");
  }, []);
  return (
    <>
      <div
        style={{
          position: "relative",
          minHeight: "20rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Modal
          small
          restrictClose
          handleClose={() => closeHandler()}
          open={isOpen}
          headingId="info-modal"
          stickyHeader="Sticky Header"
        >
          <p>{title}</p>
          <hr />
          <ModalHeading element="h5">{message}</ModalHeading>
          <ButtonGroupWrapper actionbar>
            <ButtonGroupPrimary>
              <OutlinedButton
                className="ln-u-margin-right"
                onClick={() => handleClose(false)}
              >
                Cancel
              </OutlinedButton>
              <FilledButton onClick={() => confirm()}>Yes</FilledButton>
            </ButtonGroupPrimary>
          </ButtonGroupWrapper>
        </Modal>
      </div>
    </>
  );
};

export default DuTypePopupDelete;
